import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state() {
    return {
      parentEventInfo: null,
      childEventInfo: null,
      isDuplicateUser: false,
      isErrorAddress: false,
      phoneInfo: {},
      isErrorUser: false,
      isValidUser: false,
      isBlockedSms: false,
      isValidKeyword: false,
    };
  },
  mutations,
  actions,
  getters,
  namespaced: true
};
